import { Suspense } from 'react';
import ReactDOM from 'react-dom';

import { omit as _omit } from 'lodash';

import * as Consts from 'constants/index';
import { initializeSentry } from 'config/sentry';

import Core from './components/Core';

const defaultConfig = {
    sentry: process.env.NODE_ENV === Consts.env.PRODUCTION,
    rootId: 'root',
};

export default function CoreRenderer(customConfig) {
    const config = {
        ...defaultConfig,
        ...customConfig,
    };

    const render = (Component, SuspenseFallback) => {
        if (config.sentry) {
            initializeSentry();
        }

        ReactDOM.render(
            <Core {..._omit(config, 'rootId')}>
                {props => (
                    <Suspense fallback={<SuspenseFallback />}>
                        <Component {...props} />
                    </Suspense>
                )}
            </Core>,
            document.getElementById(config.rootId),
        );
    };

    return {
        render,
    };
}
